import { render, staticRenderFns } from "./SkeletonList.vue?vue&type=template&id=9d1ff2c0"
import script from "./SkeletonList.vue?vue&type=script&lang=js"
export * from "./SkeletonList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports